import { http } from '../../core/services/http';

export const loadBusinessTypes = () =>
  http.get('common/systemTypes/customerbusinesstypes').then(response => response.data);
